import { SearchSuggest, SearchSuggestActionOption, SearchSuggestFooterAction, SearchSuggestOption } from '../search';
import { Select, SelectFooterAction } from './Select';

export type FormPickerVariant = 'select' | 'search-suggest';

export interface SelectOrSearchSuggestProps {
    variant?: FormPickerVariant;
    options: SearchSuggestOption[];
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    selectPlaceholder?: string;
    disabled?: boolean;
    hasError?: boolean;
    emptyMessage?: string;
    actionOption?: SearchSuggestActionOption;
    footerAction?: SearchSuggestFooterAction | SelectFooterAction;
    className?: string;
    inputId?: string;
    ariaLabel?: string;
    onBlur?: () => void;
    onInputKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    onTriggerKeyDown?: (event: React.KeyboardEvent<HTMLButtonElement>) => void;
    ariaDescribedBy?: string;
    formatDisplayValue?: (value: string) => string;
}

export const SelectOrSearchSuggest = ({
    variant = 'select',
    options,
    value,
    onChange,
    placeholder = 'Type to search...',
    selectPlaceholder = 'Select...',
    disabled = false,
    hasError = false,
    emptyMessage,
    actionOption,
    footerAction,
    className,
    inputId,
    ariaLabel,
    onBlur,
    onInputKeyDown,
    onTriggerKeyDown,
    ariaDescribedBy,
    formatDisplayValue,
}: SelectOrSearchSuggestProps) => {
    if (variant === 'search-suggest') {
        return (
            <SearchSuggest
                options={options}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                hasError={hasError}
                emptyMessage={emptyMessage}
                actionOption={actionOption}
                footerAction={footerAction}
                className={className}
                inputId={inputId}
                ariaLabel={ariaLabel}
                onBlur={onBlur}
                onInputKeyDown={onInputKeyDown}
                ariaDescribedBy={ariaDescribedBy}
                formatDisplayValue={formatDisplayValue}
            />
        );
    }

    return (
        <Select
            options={options}
            value={value}
            onChange={onChange}
            placeholder={selectPlaceholder}
            disabled={disabled}
            hasError={hasError}
            emptyMessage={emptyMessage}
            actionOption={
                actionOption
                    ? {
                          label: actionOption.label,
                          onClick: () => actionOption.onClick({ searchText: '' }),
                      }
                    : undefined
            }
            footerAction={actionOption ? undefined : (footerAction as SelectFooterAction | undefined)}
            className={className}
            ariaLabel={ariaLabel}
            onBlur={onBlur}
            onTriggerKeyDown={onTriggerKeyDown}
            ariaDescribedBy={ariaDescribedBy}
        />
    );
};
